var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-rejection-reason-overlay"},[_c('p',{staticClass:"small"},[_c('strong',[_vm._v("Card was declined by:")]),_vm._v(" "+_vm._s(_vm.card.RejectedBy)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"small"},[_c('strong',[_vm._v("Decline reason:")]),_vm._v(" "+_vm._s(_vm.card.RejectReason)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cdc4daf","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_modules/Programs/Card-list/CardRejectInfo.vue
// module id = mmgJ
// module chunks = 12